<template>
    <div>
        <div class="participation">
            <div class="part-box">
                <div class="part-num">{{ dataInfo.totalStudent ? formattedNumber(dataInfo.totalStudent, 0) : 0 }}</div>
                <p>本校下发问卷总量</p>
            </div>
            <div class="part-box">
                <div class="part-num">{{ dataInfo.participant ? formattedNumber(dataInfo.participant, 0) : 0 }}</div>
                <p>回收问卷总量</p>
            </div>
            <div class="part-box">
                <div class="part-num">{{ dataInfo.participantPer || 0 }}%</div>
                <p>完成率</p>
            </div>
        </div>
        <div class="average">综合评分{{ dataInfo.comprehensive || '' }}</div>
        <!-- 图表 -->
        <div class="chart-box">
            <!-- 雷达图 -->
            <div class="chart-item">
                <div class="chart1"></div>
                <div class="chart-list">
                    <p>平均分</p>
                    <div class="score" v-for="(item, index) in dimensionInfo" :key="item.id"
                        :class="{ 'blue': index === 1 || index === 3 }">
                        <span class="score-name">{{ item.dimensionTitle }}</span>
                        <span class="score-num" style='margin-left:12px'>{{ item.dataValueAverage.toFixed(1) }}</span>
                    </div>
                </div>
            </div>
            <!-- 饼图 -->
            <div class="chart-item">
                <div class="chart2"></div>
                <div class="chart-list">
                    <p style="padding-left: 102px;">占比</p>
                    <div class="score">
                        <span class="score-name">5分</span>
                        <span class="score-num tar">
                            {{ dataInfo.score5 }}%
                        </span>
                    </div>
                    <div class="score blue">
                        <span class="score-name">4分</span>
                        <span class="score-num tar">
                            {{ dataInfo.score4 }}%
                        </span>
                    </div>
                    <div class="score">
                        <span class="score-name">3分</span>
                        <span class="score-num tar">
                            {{ dataInfo.score3 }}%
                        </span>
                    </div>
                    <div class="score blue">
                        <span class="score-name">2分</span>
                        <span class="score-num tar">
                            {{ dataInfo.score2 }}%
                        </span>
                    </div>
                    <div class="score">
                        <span class="score-name">1分</span>
                        <span class="score-num tar">
                            {{ dataInfo.score1 }}%
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import * as echarts from 'echarts';
import questionnaire from '../../../api/questionnaire';

export default {
    name: 'AnalyticsStatistics',
    props: {
        formId: {
            type: Number
        },
    },
    data() {
        return {
            dataInfo: {}, // 统计数据
            dimensionInfo: [], // 维度数据
            pieChart: null,
            radarChart: null,
            schoolId: Vue.ls.get('schoolId')
        }
    },
    created() {
    },
    mounted() {
        Promise.all([this.getDimensionAverage(), this.getScorePercentage()]).then(() => {
            this.$nextTick(() => {
                this.radarChartInit(this.dimensionInfo)
                this.pieChartInit(this.dataInfo)
            })
        })
    },
    methods: {
        // 维度平均分
        async getDimensionAverage() {
            const { data } = await questionnaire.getDimensionAverage(this.formId,this.schoolId)
            if (data.length) {
                data.sort((a, b) => a.dimensionId - b.dimensionId)
                this.dimensionInfo = data
            } else {
                this.dimensionInfo = [
                    { dimensionTitle: '课程', dataValueAverage: 0 },
                    { dimensionTitle: '教师', dataValueAverage: 0 },
                    { dimensionTitle: '客服', dataValueAverage: 0 },
                    { dimensionTitle: '平台', dataValueAverage: 0 },
                    { dimensionTitle: '教务', dataValueAverage: 0 },
                ]
            }
            // console.log(this.dimensionInfo, '维度平均分')
        },
        // 分数占比
        async getScorePercentage() {
            const { data } = await questionnaire.getScorePercentage(this.formId,this.schoolId)
            if (data && data.evaluationId) {
                data.scoreTotal = data.score1 + data.score2 + data.score3 + data.score4 + data.score5
                data.comprehensive = data.participant && data.scoreTotal ? ((data.score1 * 1 + data.score2 * 2 + data.score3 * 3 + data.score4 * 4 + data.score5 * 5) / data.scoreTotal).toFixed(1) : 0
                data.participantPer = data.participant ? (data.participant * 100 / data.totalStudent).toFixed(2) : 0
                if(data.scoreTotal) {
                    data.score1=(data.score1 * 100 / data.scoreTotal).toFixed(2) 
                    data.score2=(data.score2 * 100 / data.scoreTotal).toFixed(2) 
                    data.score3=(data.score3 * 100 / data.scoreTotal).toFixed(2) 
                    data.score4=(data.score4 * 100 / data.scoreTotal).toFixed(2) 
                    data.score5=(data.score5 * 100 / data.scoreTotal).toFixed(2) 
                }
                this.dataInfo = data
            } else {
                this.dataInfo = { score1: 0, score2: 0, score3: 0, score4: 0, score5: 0, comprehensive: 0 }
            }
            // console.log(this.dataInfo, '分数占比')
        },
        // 饼图
        pieChartInit(data) {
            this.pieChart = echarts.init(document.querySelector('.chart2'))
            // 指定图表的配置项和数据
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}  {c} %'
                },
                color: ['#44D536', '#EEE100', '#FF9E00', '#FF6237', '#EE0825'],
                title: {
                    zlevel: 0,
                    text: data.comprehensive,
                    top: '40%',
                    left: '48%',
                    textAlign: 'center',
                    textStyle: {
                        rich: {
                            value: {
                                color: '#35383E',
                                fontSize: 20,
                                lineHeight: 20,
                            },
                            name: {
                                color: '#909399',
                                fontSize: 6,
                                lineHeight: 20,
                            },
                        },
                    },
                },
                series: {
                    name: '分数占比',
                    type: 'pie',
                    radius: ['30%', '60%'],
                    top: -20,
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 2,
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '40',
                            fontWeight: 'bold',
                        },
                    },
                    data: [
                        { value: data.score5, name: '5分' },
                        { value: data.score4, name: '4分' },
                        { value: data.score3, name: '3分' },
                        { value: data.score2, name: '2分' },
                        { value: data.score1, name: '1分' }
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                },
            }

            // 使用刚指定的配置项和数据显示图表。
            this.pieChart.setOption(option);
        },
        // 雷达图
        radarChartInit(data) {
            // if (!data) return
            let dataArr = data.map(item => { return item.dataValueAverage.toFixed(1) })
            this.radarChart = echarts.init(document.querySelector('.chart1'))
            var option = {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis',
                    borderColor: '#e7eefe',
                },
                legend: {
                    left: 'center',
                },
                radar: {
                    indicator: [
                        { name: data[0].dimensionTitle, max: 5 },
                        { name: data[1].dimensionTitle, max: 5 },
                        { name: data[2].dimensionTitle, max: 5 },
                        { name: data[3].dimensionTitle, max: 5 },
                        { name: data[4].dimensionTitle, max: 5 },
                    ],
                },
                series: [
                    {
                        name: '维度平均分',
                        type: 'radar',
                        tooltip: {
                            trigger: 'item'
                        },
                        areaStyle: {},
                        data: [
                            {
                                value: dataArr,
                                symbol: 'none',
                                areaStyle: {
                                    color: '#e7eefe'
                                },
                                lineStyle: {
                                    color: '#41a3ff'
                                }
                            }
                        ]
                    },
                ]
            }
            this.radarChart.setOption(option);
        },
        // 数据加逗号
        formattedNumber(num) {
            return new Intl.NumberFormat('en-US').format(num);
        },
    }
}
</script>

<style lang="less" scoped>
.participation {
    height: 103px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .part-box {
        width: 32%;
        height: 100%;
        border-radius: 8px;
        border: 1px solid #F0F2F5;
        text-align: center;

        .part-num {
            margin-top: 24px;
            font-weight: 600;
            font-size: 24px;
            color: #000000;
            line-height: 24px;
            margin-bottom: 5px;
        }

        p {
            font-size: 14px;
            color: #171A1D;
        }
    }
}

.average {
    margin-top: 24px;
    height: 70px;
    background: #FAFAFA;
    font-weight: 600;
    font-size: 24px;
    color: #000000;
    text-align: center;
    line-height: 70px;
}

.chart-box {
    height: 226px;
    margin: 24px 0 12px;
    display: flex;

    .chart-item {
        flex: 1;
        display: flex;

        .chart1,
        .chart2 {
            width: 280px;
            // height: 226px;
        }

        .chart-list {
            width: 158px;
            margin: 13px 25px;
            color: #35383E;

            p {
                padding-left: 87px;
            }

            .score {
                height: 32px;
                line-height: 32px;

                .score-name {
                    margin: 0 34px 0 23px;
                }

                .tar {
                    display: inline-block;
                    width: 60px;
                    text-align: right;
                }
            }

            .blue {
                background: #F2F9FC;
            }
        }
    }
}
</style>